module.exports = __webpack_public_path__ + "img/tencenttke-black.58828585.svg";